/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Image) GS.Toolbar.Image={};
GS.Toolbar.Frame.FitTools=new Class({
    Extends: GS.Toolbar.Tools,
    class_name:'GS.Toolbar.Frame.FitTools',
    options:{
        'wrapper': null,
        'class':'submenu full',
        'lexico':{
            'ff' : 'Fit to spread',
            'fp' : 'Fit to page'
        },
        'toolbar':null
    },
    controlled:null,
    
    initialize:function(conf){
       this.options.lexico=Locale.get('Toolbar.fit_menu');
       this.parent(conf);
       //console.log('INIT FITTING TOOLS');
    },

    updatePermissions: function(permissions){
        this.parent(permissions);
        var fp, fs;
        fp = this.sm ? this.sm.querySelector('[data-type="fit-page"]') : null;
        fs = this.sm ? this.sm.querySelector('[data-type="fit-fullpage"]') : null;
        if(fp) fp.style.display = 'inline-block';
        if(fs) fs.style.display = 'inline-block';
        if(permissions.fit && typeof permissions.fit !== 'boolean'){
            if(!permissions.fit.fit_to_page && fp) fp.style.display = 'none';
            if(!permissions.fit.fit_to_spread && fs) fs.style.display = 'none';
        }
    }
});

/**
     * 
     * @param {Object} permissions
     * @returns {void}
     */
/*GS.Toolbar.Image.GeometryTools.prototype.updatePermissions=function(permissions){
        var vis=false,
            self=this,
            use=this.options.permission_property;

        if(!use.pop) use=[use];
        
        Array.each(use,function(prop,i){
            
            if(typeof permissions[prop]==='object'){
                Object.each(permissions[prop],function(v,p){
                    console.debug('Property: %s, value: %s',prop,v);
                    if(v) vis=true;
                    self.fireEvent(p,v);
                });
            }else{
                if(permissions[prop]===true) vis=true;
                self.fireEvent(prop,permissions[prop]);
            }
        });
        this.options.wrapper.setStyle('display',(vis) ? 'block' : 'none');
        if(vis) this.toolbar.fireEvent('show');
    };*/

/*GS.Toolbar.Frame.FitTools.prototype.updatePermissions=function(permissions){
    this.parent(permissions);
    console.warn('--->', permissions);
};*/

GS.Toolbar.Frame.FitTools.prototype.menuTMPL=function(){
    var out='';
    out+='<li class="fit-fullpage" data-type="fit-fullpage" title="{ff}"></li>';
    out+='<li class="fit-page" data-type="fit-page" title="{fp}"></li>';
    return out;
};